import { useSetRecoilState } from "recoil";
import apiClient from "../lib/apiClient";
import { loadingState, loadingText } from "../states/LoadingState";
import { getFormattedTimestamp } from "../functions/formatting";

export const useMergePdf = (setIsshow) => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const mergePdf = async (drawingList) => {
    try {
      // ボタンを無効化するなどのUI操作があればここで
      setLoadingAnimation(true);
      setLoadingText("結合中...");
      // 選択されたPDFのURLリストを作成
      const urls = drawingList.map((item) => item.url);

      if (urls.length === 0) {
        alert("PDFが選択されていません");
        return;
      }

      // APIコールしてPDFをダウンロード
      const response = await apiClient.post(
        "/Drawing/merge-pdfs",
        { urls },
        {
          responseType: "blob", // 重要: バイナリデータとして受け取る
        }
      );

      // ダウンロードリンクを作成
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${drawingList[0].productNo}_${
          drawingList.length
        }ファイル結合_${getFormattedTimestamp()}.pdf`
      ); // ファイル名を指定
      document.body.appendChild(link);
      link.click();

      // クリーンアップ
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      setIsshow(false); // モーダルを閉じる
    } catch (error) {
      console.error("Error combining PDFs:", error);
      alert("PDFの結合中にエラーが発生しました");
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  return { mergePdf };
};
